export class EmployerContactModel {
    employerContactId: number;
    firstName: string = '';
    lastName: string = '';
    position: string = '';
    mobile: string = '';
    email: string = '';
}